import React, { useState } from 'react';
import styles from './AppSettings.module.css';
import Modal from 'react-modal';
import axios from 'axios';
import Toast from '../common/toast/Toast';
function AppSettingsConfig() {

	const [modalIsOpen, setIsOpen] = React.useState(false);
	const [modalTCIsOpen, setIsTCOpen] = React.useState(false);
	// state for is Error
	const [showToast, setShowToast] = useState(false);
	// state for error message
	const [errorMessage, setErrorMessage] = useState('');
	const [errorType, setErrorType] = useState('');
	function openModal() {
		setIsOpen(true);
	}

	function openModalTC() {
		setIsTCOpen(true);
	}

	function closeModal() {
		setIsOpen(false);
		setIsTCOpen(false);
	}
	const customStyles = {
		content: {
			top: '50%',
			left: '50%',
			right: 'auto',
			bottom: 'auto',
			marginRight: '-50%',
			transform: 'translate(-50%, -50%)',
		},
	};

	const updateStatus = async (field: string) => {
		try {
			setShowToast(false)
			const result = await axios.patch(`/admin/Admin-dash-action?${field}=true`)
			if (result.data.statusCode === 200) {
				setErrorMessage(result.data.message)
				setShowToast(true)
				setErrorType('success')
				closeModal()
			} else {
				setErrorMessage(result.data.message)
				setShowToast(true)
				setErrorType('error')
			}
		} catch (error: any) {
			setErrorMessage(error.message)
			setShowToast(true)
			setErrorType('error')
		}
	}

	return (
		<>
			{showToast && <Toast type={errorType} message={errorMessage} />}
			<div className='outletConainer'>
				<p className={styles.pageTitle}>Visitor Page Settings</p>
				<div className={styles.buttonContainer}>
					<button className={styles.btnGreen} onClick={openModal}>Logout All Users</button>
					<button className={styles.btnGreen} onClick={openModalTC} style={{ marginLeft: '10px' }}>Update T&C</button>
				</div>
			</div>

			<div>
				<Modal
					isOpen={modalIsOpen}
					onRequestClose={closeModal}
					style={customStyles}
					appElement={document.getElementById('root') as HTMLElement}
					contentLabel="Logout Modal"
				>
					<h2 >Logout all the users ?</h2>
					<p>Are you sure to logout all the users ?</p>
					<div style={{ flexDirection: 'row', justifyContent: 'flex-end', display: 'flex' }}>
						<button className={styles.btnRed} onClick={closeModal} >No</button>
						<button className={styles.btnGreen} onClick={() => updateStatus('loggedOutAll')} style={{ marginLeft: '10px' }} >Yes</button>
					</div>
				</Modal>
				<Modal
					isOpen={modalTCIsOpen}
					onRequestClose={closeModal}
					style={customStyles}
					appElement={document.getElementById('root') as HTMLElement}
					contentLabel="T&C Modal"
				>
					<h2 >Force update T&C ?</h2>
					<p>Are you sure to force update T&C ?</p>
					<div style={{ flexDirection: 'row', justifyContent: 'flex-end', display: 'flex' }}>
						<button className={styles.btnRed} onClick={closeModal} >No</button>
						<button className={styles.btnGreen} onClick={() => updateStatus('updateTNC')} style={{ marginLeft: '10px' }} >Yes</button>
					</div>
				</Modal>
			</div>

		</>
	)
}

export default AppSettingsConfig